import { motion } from 'framer-motion';

interface AnimatedTitleProps {
  text: string;
  className?: string;
  gradientFrom?: string;
  gradientTo?: string;
  delay?: number;
}

export function AnimatedTitle({
  text,
  className = "",
  gradientFrom = "var(--foreground)",
  gradientTo = "color-mix(in oklab, var(--foreground) 70%, transparent)",
  delay = 0
}: AnimatedTitleProps) {

  // Variants for staggered typing effect
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
        delayChildren: delay
      }
    }
  };

  const charVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring" as const,
        damping: 12,
        stiffness: 100
      }
    }
  };

  return (
    <div className="group/animated-title w-fit mx-auto relative cursor-default">
      <motion.h2
        className={`relative z-10 font-bold bg-clip-text text-transparent ${className}`}
        style={{
          backgroundImage: `linear-gradient(to right bottom, ${gradientFrom}, ${gradientTo})`
        }}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        {text.split('').map((char, index) => (
          <motion.span key={index} variants={charVariants} className="inline-block">
            {char === ' ' ? '\u00A0' : char}
          </motion.span>
        ))}
      </motion.h2>
    </div>
  );
}
